import axios, { AxiosInstance } from 'axios';
import * as Raven from 'raven-js';
import { ACCOUNT_BASE_URL } from 'app/common/constants/defaultUrl';

class AxiosSingleton {
  private static instance: AxiosInstance;
  public static getInstance() {
    return AxiosSingleton.instance
      ? AxiosSingleton.instance
      : (AxiosSingleton.instance = axios.create({
          withCredentials: true,
        }));
  }
}

export const makeLoginURI = (
  authorizeURI: string,
  clientId: string,
  redirectURI: string,
) =>
  `${authorizeURI}?client_id=${clientId}&response_type=code&redirect_uri=${redirectURI}`;

export const createAxiosWithOauth2Handling = () => {
  const instance = AxiosSingleton.getInstance();
  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        if (error.response.config.url !== `${ACCOUNT_BASE_URL}/ridi/token/`) {
          return instance
            .post(`${ACCOUNT_BASE_URL}/ridi/token/`, null, {
              withCredentials: true,
            })
            .then(() => instance(error.response.config))
            .catch(e => {
              const currentURI = makeLoginURI(
                `${ACCOUNT_BASE_URL}/ridi/authorize/`,
                process.env.OAUTH2_CLIENT_ID ||
                  'Nkt2Xdc0zMuWmye6MSkYgqCh9q6JjeMCsUiH1kgL',
                location.href,
              );

              location.href = currentURI;
              return null;
            });
        }
        return axios
          .get(`${ACCOUNT_BASE_URL}/ridi/authorize/`, {
            withCredentials: true,
            params: {
              client_id:
                process.env.OAUTH2_CLIENT_ID ||
                'Nkt2Xdc0zMuWmye6MSkYgqCh9q6JjeMCsUiH1kgL',
              response_type: 'code',
              redirect_uri: `${ACCOUNT_BASE_URL}/ridi/complete`,
            },
          })
          .then(() => instance(error.response.config))
          .catch(e => {
            if (e.response.status !== 401) {
              Raven.captureException(e, {
                tags: {
                  api: 'account',
                  action: 'oauth',
                },
              });
            }
            return Promise.reject(e);
          });
      }
      return Promise.reject(error);
    },
  );

  return instance;
};



// WEBPACK FOOTER //
// ./common/authHelper.ts